package team.platforma.dictionary_domain

import team.platforma.dictionary_domain.use_case.ai_chapter.AiChapterTableUseCase
import team.platforma.dictionary_domain.use_case.ai_chapter.NetworkAiChapterUseCase

data class AiChapterUseCase(
    val network: NetworkAiChapterUseCase,
    val table: AiChapterTableUseCase
)
